import { createReducer, on } from '@ngrx/store';
import { setChartOption, setCurrencyOption } from './chart-options.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { CONVERT_CURRENCY_DEFAULT } from 'ChartApp/ts/features/fundamental-chart/constants';
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
export const convertCurrency = createReducer(CONVERT_CURRENCY_DEFAULT, on(setChartData, (state, { chartData }) => !!chartData.params.convertCurrency), on(setChartOption, (state, action) => {
    if (action.chartOption.value === FundChartOptionValue.CONVERT_CURRENCY) {
        return action.chartOption.selected;
    }
    return state;
}), 
// Picking a currency is an intent to convert, so it also switches on currency conversion
on(setCurrencyOption, () => true), on(setFundChart, (state, action) => !!action.fundChart[FundChartOptionValue.CONVERT_CURRENCY]));
